"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.deleteNullProps = void 0;
const deleteNullProps = (obj, options = { emptyString: false }) => {
    if (obj) {
        Object.keys(obj).forEach(prop => {
            if (obj[prop] && typeof obj[prop] === 'object' && !Array.isArray(obj[prop]) && !(obj[prop] instanceof Date)) {
                obj[prop] = (0, exports.deleteNullProps)(obj[prop]);
                // Delete the property if it is an empty object or just a __typename after cleaning
                const objKeys = Object.keys(obj[prop]);
                if (objKeys.length === 0 || (objKeys.length === 1 && objKeys.includes('__typename'))) {
                    delete obj[prop];
                }
            }
            else if (obj[prop] === null || obj[prop] === undefined || (options.emptyString && obj[prop] === '')) {
                delete obj[prop];
            }
        });
    }
    return obj;
};
exports.deleteNullProps = deleteNullProps;
//# sourceMappingURL=deleteNullProps.js.map